<template>
  <span
    class="text-break"
    v-html="nl2br(data.value)"
  />
</template>

<script>
import { nl2br } from '@/filters/text'
import BaseDisplayType from './Base.vue'

export default {
  name: 'TextDisplayType',
  extends: BaseDisplayType,
  data() {
    return {
      nl2br,
    }
  },
}
</script>

<style scoped>

</style>
